__turbopack_context__.v({
  "className": "inter_ff7cf73e-module__2ZNINW__className",
});
